module.exports = __webpack_public_path__ + "static/media/eu_verdadeiro_7.4ae8fa8f.jpg";